import { DecimalPipe } from "@angular/common";
import { Component, Input, Output, EventEmitter } from "@angular/core";
import { DomSanitizer } from "@angular/platform-browser";
import { Observable, Subject, Subscription } from "rxjs";
import { AddressModel } from "src/app/core/models/address.model";
import { BusinessUnit } from "src/app/core/models/org/bussiness-unit.model";
import { UserBaseModel } from "src/app/core/models/members/user/user-base.model";
import { LoginType } from "src/app/core/models/members/user/user-context.model";
import { UserModel, AccountStatus } from "src/app/core/models/members/user/user.model";
import { UserListService } from "src/app/core/services/list-services/user-list.service";

import { MyfileApiService } from "src/app/core/services/myfile-api.service";
import { ToasterNotificationService } from "src/app/core/services/toaster-notification.service";
import { GlobalComponent } from "src/app/global-component";
import Swal from "sweetalert2";
import { AuthMyfileService } from "src/app/core/services/auth.myfile.service";
import { OpenModalService } from "src/app/core/services/modal-services/open-modal.service";
import { PdfViewerModalService } from "src/app/core/services/modal-services/pdf-viewer-modal.service";
import { UserListSortBy } from "src/app/core/enums/sort-by-options/user-list-sort-enum";
import { EntityTypeEnum } from "src/app/core/enums/entity-type-id-enum";
import { NgSelectListModel } from "src/app/core/models/ng-select-list.model";
import { ButtonIdEnum } from "src/app/core/enums/list-layout/button-id-enum";
import { ActionIdEnum } from "src/app/core/enums/list-layout/action-id-enum";
import { TableActionsModel } from "src/app/core/models/table/table-action.model";
import { ExportType } from "src/app/core/models/reporting/export-config-model";
import { ListFilterModel } from "src/app/core/models/table/list-filter.model";
import { UserListTableConfig } from "./configs/user-list.config";
import { ListLayoutExtendableComponent } from "../list-layout/list-layout-extendable/list-layout-extendable.component";
import { ServiceData } from "src/app/core/models/table/service-data.model";
import { TableConfigurationModel } from "src/app/core/models/table/table-configuration.model";
import { SortByTypeEnum } from "src/app/core/enums/list-layout/sort-type-enum";
import { EmitSortModel } from "src/app/core/models/table/emit-sort.model";
import { Roles } from "src/app/core/security/roles";
import { TableConfigService } from "src/app/core/services/table-config.service";
import { TableUserFilter } from "./configs/table-userlist-filter-config-enum";
import { InviteModalService } from "src/app/core/services/modal-services/invite-modal.service";
import { UserPermissionModalService } from "src/app/core/services/modal-services/user-permission-modal.service";


@Component({
  selector: 'app-user-list',
  templateUrl: './user-list.component.html',
  styleUrls: ['./user-list.component.scss'],
  providers: [UserListService, DecimalPipe],
})
export class UserListComponent extends ListLayoutExtendableComponent {

  serviceData: ServiceData = new ServiceData();
  tableConfig: TableConfigurationModel = new TableConfigurationModel();

  sortBy: UserListSortBy = UserListSortBy.None;
  enumUserListSortBy = UserListSortBy;

  viewModel: boolean = false;
  model: UserModel = new UserModel();

  // Table data
  override listItemsObservable!: Observable<UserBaseModel[]>;

  selectedModelsArray: any[] = [];
  users$?: Observable<any>;
  usersLoading = false;
  userInput$ = new Subject<string>();

  tenantList: NgSelectListModel[] = [];
  currentTenantId?: string;
  currentTenantName?: string;

  //userSelectModal = ModalType.ContactModalPickList;
  protected override searchPlaceHolderText: string = "Search for user number, name, company name, or email";

  selectedModelIdFromCheckedList: string = "";

  configItemsObservable!: Observable<TableConfigurationModel[]>;

  constructor(
    public userListService: UserListService,
    private userPermissionModalService: UserPermissionModalService,
    private myInviteModalService: InviteModalService,
    private tableConfigService: TableConfigService,
    protected override myFileApiService: MyfileApiService,
    protected override sanitizer: DomSanitizer,
    protected override pdfModalService: PdfViewerModalService,
    protected override authMyFileService: AuthMyfileService,
    protected override toasterNotificationService: ToasterNotificationService,
    protected override openModalService: OpenModalService,
  ) {
    super(myFileApiService, sanitizer, pdfModalService, authMyFileService, toasterNotificationService, openModalService);
  }

  @Input() public referenceModel: UserBaseModel = new UserBaseModel();
  @Input() public disabled: boolean = false;
  @Output() referenceModelChange = new EventEmitter<any>();

  ngOnInit(): void {

    this.tableConfig = new UserListTableConfig();

    this.configItemsObservable = this.tableConfigService.resultItems$;
    const subscrConfig = this.configItemsObservable.subscribe(result => {
      if (result && result[0]) {
        //needed to be able to avoid null from the model when its decoded. 
        this.tableConfig = JSON.parse(JSON.stringify(result[0], (key, value) => {
          if (value !== null) return value;
        }));
        if (this.tableConfig.pageSize !== GlobalComponent.defaultPagingInfo.pageSize) {
          this.userListService.pageSize = this.tableConfig.pageSize;
        }
      }
    });
    this.unsubscribe.push(subscrConfig);

    this.tableConfigService.createdById = this.authMyFileService.currentUserContextValue?.id;
    this.tableConfigService.listTitle = this.tableConfig.listTitle!;

    this.listItemsObservable = this.userListService.resultItems$;
    this.total = this.userListService.total$;
    this.isLoading = this.userListService.loading$;


    const subscr = this.isLoading.subscribe(result => {
      if (result) {
        this.serviceData.loadingValue = true;
      } else {
        this.serviceData.loadingValue = false;
      }
    });
    this.unsubscribe.push(subscr);

    const subscr2 = this.listItemsObservable.subscribe(result => {
      this.listItems = Object.assign([], result);
      this.listItems.forEach((userModel: UserBaseModel) => {
        this.getEntityPhoto(userModel, EntityTypeEnum.User);
        if (userModel.lastActive) {
          var lastOnLineDate: Date = new Date(userModel.lastActive); //convert to DateObject from server string Object. 
          var currentDateTime = new Date();
          if (currentDateTime.getTime() - lastOnLineDate.getTime() <= GlobalComponent.lastActiveTime) {
            userModel.isOnline = true;
          }
        }
      });
    });
    this.unsubscribe.push(subscr2);

    const subscr3 = this.total.subscribe(result => {
      this.serviceData.totalRecords = this.userListService.totalRecords;
      this.serviceData.pageSize = this.userListService.pageSize;
      this.serviceData.pageIndex = this.userListService.pageIndex;
      this.updateGlobalAdminFilters();
    });
    this.unsubscribe.push(subscr3);
  }

  //** new simpler sort function for futher lists with new layout component */
  sortByPassedSort(passedSortModel: EmitSortModel) {
    if (passedSortModel.sortSelected == SortByTypeEnum.None) {
      this.serviceSort(this.userListService, '', '');
    } else {
      this.serviceSort(this.userListService, passedSortModel.fieldName, passedSortModel.sortSelected);
    }
  }

  updateGlobalAdminFilters() {
    if (this.authMyFileService.isInRole(Roles.globalAdmin) && this.tableConfig.filters![1].label == undefined) {
      var sub = this.myFileApiService.getSystemTenants().subscribe(tenantList => {
        this.tenantList = [];
        if (tenantList) {
          var sub2 = this.myFileApiService.getBusinessUnitForCurrentUser().subscribe(result => {
            if (result) {
              this.currentTenantName = result.name;
              this.currentTenantId = result.tenantId;

              tenantList.tenants.forEach((tenant: BusinessUnit) => {
                if (tenant.tenantId == result.tenantId) {
                  this.tenantList.splice(0, 0, new NgSelectListModel(tenant.tenantId, tenant.name, undefined, undefined, true));
                } else {
                  this.tenantList.push(new NgSelectListModel(tenant.tenantId, tenant.name));
                }
              });

              this.tableConfig.filters![1] =
              {
                label: TableUserFilter.UserTenantFilter,
                options: this.tenantList,
                selectedOption: result.tenantId,
                inDropdown: true,
                inHeading: false,
                inButton: false,
                removeAllDataReturnPlaceHolder: true
              }

            }
            sub2.unsubscribe();
          })
        }
        sub.unsubscribe();
      })
    }
  }

  ngOnDestroy() {
    this.clearSearch(this.tableConfigService);
    this.clearSearch(this.userListService);
    this.unsubscribe.forEach((sb) => sb.unsubscribe());
  }

  updateSelectedTenant(tenant?: NgSelectListModel) {
    if (tenant) {
      this.currentTenantName = tenant.selectedText;
      this.currentTenantId = tenant.value;
      this.userListService.tenantId = tenant.value;
    }
  }

  enableUsers() {
    if (this.checkedValGet.length == 0) {
      Swal.fire({
        icon: 'warning',
        text: 'Please select at least one user',
        color: 'var(--vz-body-color)',
        background: 'var(--vz-body-bg)',
        confirmButtonColor: '#299cdb',
      });
    } else {
      var userIDs: string[] = [];
      this.checkedValGet.forEach(user => {
        userIDs.push(user.id)
      })
      this.isLoadingVal = true;
      this.myFileApiService.enableUsers(userIDs).subscribe(result => {
        if (result) {
          this.checkedValGet = [];
        }
        this.userListService.startIndex = this.userListService.startIndex;
        this.isLoadingVal = false;
      });
    }
  }

  disableUsers() {
    if (this.checkedValGet.length == 0) {
      Swal.fire({
        icon: 'warning',
        text: 'Please select at least one user',
        color: 'var(--vz-body-color)',
        background: 'var(--vz-body-bg)',
        confirmButtonColor: '#299cdb',
      });
    } else {
      var userIDs: string[] = [];
      this.checkedValGet.forEach(user => {
        userIDs.push(user.id)
      })
      this.isLoadingVal = true;
      this.myFileApiService.disableUsers(userIDs).subscribe(result => {
        if (result) {
          this.checkedValGet = [];
        }
        this.userListService.startIndex = this.userListService.startIndex;
        this.isLoadingVal = false;
      });
    }
  }

  sideProfileView(modelId: string) {
    this.viewModel = true;
    this.isLoadingVal = true;
    var sub: Subscription = this.myFileApiService.getUser(modelId, this.currentTenantId)
      .subscribe((userModel: UserModel | undefined) => {
        if (userModel) {
          this.model = userModel;
        }
        this.isLoadingVal = false;
        sub.unsubscribe();
      });
  }

  signaturePNGTransform() {
    if (this.model.signature) {
      return this.sanitizer.bypassSecurityTrustResourceUrl(`data:image/png;base64, ${this.model.signature}`);
    }
    return GlobalComponent.defaultNoSignatureImage;
  }

  openInviteModal() {
    this.myInviteModalService.openModal(LoginType.User);
  }

  openModalPermissions(userBaseModel: any) {
    this.userPermissionModalService.openModal(userBaseModel)
    var sub: Subscription = this.userPermissionModalService.modelChanged.subscribe((result: any) => {
      this.userListService.startIndex = this.userListService.startIndex;
      this.submitted = false;
      sub.unsubscribe();
    })
  }

  openView(user: UserBaseModel) {
    this.submitted = true;
    this.loadUser(user);
    this.viewModel = true;
  }

  loadUser(user: UserBaseModel) {
    this.myFileApiService.getUser(user.id, this.currentTenantId).subscribe((userModel) => {
      if (userModel) {
        if (!userModel.address) {
          userModel.address = new AddressModel();
        }
        this.model = userModel;
        this.model.listPhoto = user.listPhoto;
      }
      this.submitted = false;
    })
  }

  statusText(status: AccountStatus) {
    switch (status as AccountStatus) {
      case AccountStatus.Approved:
        return $localize`:@@Status_Text_Approved:Approved`;
      case AccountStatus.Disabled:
        return $localize`:@@Status_Text_Disabled:Disabled`;
      case AccountStatus.Pending:
        return $localize`:@@Status_Text_Pending:Pending`;
      case AccountStatus.Onboarding:
        return $localize`:@@Status_Text_Onboarding:Onboarding`;
      case AccountStatus.PasswordReset:
        return $localize`:@@Status_Text_PasswordReset:Password Reset`;
      default:
        return '';
    }
  }

  buttonActionSelected(buttonAction: any) {

    switch (buttonAction) {
      case ButtonIdEnum.CreateNew:
        this.openModalService.newUserModal(this.currentTenantId!, this.userListService);
        break;
      case ButtonIdEnum.Invite:
        this.openInviteModal();
        break;
      case `${ButtonIdEnum.Enable}`:
        this.enableUsers();
        break;
      case `${ButtonIdEnum.Disable}`:
        this.disableUsers();
        break;
      case `${ButtonIdEnum.ExportCSV}`:
        this.exportTo(ExportType.Csv, this.userListService.searchModel, 'Users', 'Users', this.tableConfig)
        break;
      case `${ButtonIdEnum.ExportExcel}`:
        this.exportTo(ExportType.Excel, this.userListService.searchModel, 'Users', 'Users', this.tableConfig)
        break;
    }
  }

  rowActionSelected(rowAction: TableActionsModel) {
    switch (rowAction.actionIdSelected) {
      case ActionIdEnum.Edit:
        if (rowAction.model == undefined || rowAction.model.id == undefined || rowAction.model.businessUnit == undefined) {
          this.toasterNotificationService.showError($localize`:@@Toast_Error_GeneralText:Something went wrong. Please try again later.`, $localize`:@@Toast_Error_GeneralTitle:Error`);
          return;
        }
        this.openModalService.editUserModal(rowAction.model.id, rowAction.model.businessUnit.tenantId, this.userListService, undefined, undefined);
        break;
      case ActionIdEnum.Security:
        if (rowAction.model == undefined || rowAction.model.id == undefined || rowAction.model.businessUnit == undefined) {
          this.toasterNotificationService.showError($localize`:@@Toast_Error_GeneralText:Something went wrong. Please try again later.`, $localize`:@@Toast_Error_GeneralTitle:Error`);
          return;
        }
        this.openModalPermissions(rowAction.model);
        break;
      case ActionIdEnum.View:
        if (rowAction.model != undefined && rowAction.model.id != undefined) {
          this.sideProfileView(rowAction.model.id)
        }
        break;
    }
  }

  filterSelected(filterSelected: ListFilterModel) {
    switch (filterSelected.label) {
      case TableUserFilter.UserEnabledFilter:
        if (filterSelected.selectedOption !== undefined) {
          this.userListService.isEnabled = Boolean(filterSelected.selectedOption);
        } else {
          this.userListService.isEnabled = undefined;
        }
        break;
      case TableUserFilter.UserStatusFilter:
        this.userListService.status = filterSelected.selectedOption;
        break;
      case TableUserFilter.UserTenantFilter:
        this.currentTenantId = filterSelected.selectedOption;
        this.userListService.tenantId = filterSelected.selectedOption;
        break;
    }
  }

}

